var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 600,
    viewBox: "0 0 900 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 600,
    fill: "#E8EAED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M482.653 221.316C487.982 215.052 498.858 215.052 504.187 221.316L697.405 448.429C703.849 456.006 697.555 466.666 686.635 466.666H300.204C289.286 466.666 282.992 456.006 289.437 448.429L482.653 221.316Z",
    fill: "#A2AAB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.54 466.663H485.409H506.777L355.162 305.116C351.356 300.993 343.592 300.993 339.788 305.116L201.853 454.655C197.252 459.644 201.746 466.663 209.54 466.663Z",
    fill: "#B9BFCA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.963 185.861C306.963 214.871 283.445 238.389 254.434 238.389C225.423 238.389 201.904 214.871 201.904 185.861C201.904 156.85 225.423 133.333 254.434 133.333C283.445 133.333 306.963 156.85 306.963 185.861Z",
    fill: "#A2AAB8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageNotFound);
export default __webpack_public_path__ + "static/media/imageNotFound.96328f5d9689e7db73071d5ae4cb95c2.svg";
export { ForwardRef as ReactComponent };